import Axios from 'axios'
import store from '../store'

const calendar = {
  getClientId() {
    return store.getters['Client/clientId']
  },
  getCostCenterBaseUrl() {
    return process.env.VUE_APP_URL_COST_CENTER_BASE
  },
  getCalendarConfiguration() {
    return Axios.get('api/internal/clients/' + this.getClientId() + '/calendarConfiguration')
  },
  saveCalendarConfiguration(calendar) {
    return Axios.put(this.getCostCenterBaseUrl() + `api/v1/clients/${this.getClientId()}/configurations/rooms/calendar`, calendar)
  },
  saveCertificate(certificate) {
    let formData = new FormData()

    if (certificate) {
      formData.append('certificate', certificate)
    }

    delete calendar.certificate

    return Axios.put(`/api/internal/clients/${this.getClientId()}/certificateConfiguration`, formData)
  },
  getAuthorizationUrl() {
    return Axios.get(`/api/internal/clients/${this.getClientId()}/consent`)
  }
}
export default calendar
